import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import VerticalList from 'components/VerticalList';
import ChannelListItem from './ChannelListItem';
import { ChannelMappedWithEpg, LiveEventType } from 'store/pages/loaders/loader-types';

const SECTION_NAME = 'EPG_CHANNEL_LISTS';

const CONFIG = {
  enterTo: 'last-focused',
  leaveFor: {
    up: '',
    down: '',
    left: '',
    right: '',
  },
  debounce: {
    time: 100,
    options: {
      leading: true,
      trailing: false,
      maxWait: 200,
    },
  },
};

const ITEM_HEIGHT = scaleSize(130);

const StyledVerticalList = styled(VerticalList)`
  position: relative;
  overflow: hidden;
  top: ${scaleSize(266)}px;
  left: ${scaleSize(140)}px;
  width: 100%;
  height: ${scaleSize(800)}px;
`;

interface IChannelsList {
  defaultIndex: number;
  channels: ChannelMappedWithEpg[];
  onEnter?: (item: LiveEventType, index: number) => void;
  onFocus?: (item: LiveEventType, index: number) => void;
}

const ChannelsList: React.FC<IChannelsList> = (props) => {
  const { defaultIndex, channels, onEnter, onFocus } = props;
  return (
    <StyledVerticalList
      sectionName={SECTION_NAME}
      listId={SECTION_NAME}
      items={channels}
      config={CONFIG}
      infinite={true}
      onEnter={onEnter}
      onFocus={onFocus}
      defaultIndex={defaultIndex}
      startScrollIndex={2}
      itemComponent={ChannelListItem}
      itemHeight={ITEM_HEIGHT}
      defaultSection
    />
  );
};

export default ChannelsList;
